import z from "zod";

import { SIZES } from "@frontend/styles/constants";

import { PANEL_BORDERS, PANEL_OVERFLOWS, PANEL_WIDTHS } from "./constants";

export const panelDataSchema = z.object({
  width: z.enum(PANEL_WIDTHS).optional(),
  padding: z.enum(SIZES).optional(),
  margin: z.enum(SIZES).optional(),
  border: z.enum(PANEL_BORDERS).optional(),
  overflow: z.enum(PANEL_OVERFLOWS).optional(),
  color: z.string().optional(),
});

export type PanelDataProps = z.infer<typeof panelDataSchema>;
